//@ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import {
  baseNameIcon,
  BaseSettingIcon,
  CustomUserIcon,
  LogoutIcon,
  ProfileSettingIcon,
  SwitchBaseIcon,
  UserRoleIcon,
} from "../icons";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { toast } from "sonner";
import { logoutUser } from "../../features/auth/authSlice";
import { _baseRequest, COMMON } from "../../utils/baseApi";
import { fetchDepartmentList } from "../../features/department/departmentSlice";
import { baseDetailsData } from "../../features/base/baseSlice";
import { debounce } from "lodash";
import { fetchLocationList } from "../../features/location/locationSlice";
import { fetchPipelineStagesList } from "../../features/tags/tagsSlice";
import { fetchDocument } from "../../features/job/jobSlices";
import LoadingBar from "react-top-loading-bar";
import { ExclamationIcon } from "../icons";
import { SparkleIconComponent } from "../icons/Icons";
import { ArrowUp, X } from "lucide-react";
import {
  streamBotResponse,
  clearChat,
  setStreamDoneResponse,
} from "../../features/chat/chatSlice";

export default function BaseJobList() {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [updateProfileImage, setUpdateProfileImage] = useState("");
  const [updateBaseLogo, setUpdateBaseLogo] = useState(null);
  const dispatch = useAppDispatch();
  const [isAiPopupOpen, setIsAiPopupOpen] = useState(false);
  const [aiPopupInput, setAiPopupInput] = useState("");
  const [aiPopupMessages, setAiPopupMessages] = useState<
    { role: string; content: string; id?: string }[]
  >([]);
  const streamingAssistantIdxRef = useRef<number | null>(null);
  const aiPopupScrollRef = useRef<HTMLDivElement>(null);
  const chatMessages = useAppSelector((state: any) => state.chat.messages);
  const isChatLoading = useAppSelector((state: any) => state.chat.isLoading);
  const streamStatus = useAppSelector((state: any) => state.chat.streamStatus);
  const lastDoneResponse = useAppSelector(
    (state: any) => state.chat.lastDoneResponse,
  );

  const navigate = useNavigate();
  const [allActivityItem, setAllActivityItem] = useState({
    jobPost: [],
    totalJobPost: 0,
    currentPage: 1,
    hasNextPage: false,
    limit: 25,
    totalPages: 1,
  });
  const { jobPost } = allActivityItem;
  const [isLoading, setIsLoading] = useState(false);
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();

useEffect(() => {
    if (!lastDoneResponse) return;
    if (!isAiPopupOpen) return;
    const match = lastDoneResponse.match(/job\/([a-zA-Z0-9_-]+)\/manage\/detail/);
    if (match && match[1]) {
      const newJobId = match[1];
      setIsAiPopupOpen(false);
      setAiPopupMessages([]);
      dispatch(clearChat());
      dispatch(setStreamDoneResponse(null));
      setTimeout(() => {
        navigate(`/${baseId}/job/${newJobId}/manage/detail`);
      }, 300);
    }
  }, [lastDoneResponse, isAiPopupOpen, baseId, navigate, dispatch]);
  const [teams, setTeams] = useState(null);
  const [updateChannelName, setUpdateChannelName] = useState("");
  const [shouldLoadMore, setShouldLoadMore] = useState(false);
  const listRef = useRef(null);
  const [location, setLocation] = useState<any>(null);
  const [jobLocations, setJobLocations] = useState({});
  const [userData, setUserData] = useState<any>(null);
  const [userBaseData, setUserBaseData] = useState<any>(null);
  const userDetailsFromRedux = useAppSelector(
    (state: any) => state?.base?.baseDetails,
  );
  const [userId, setUserId] = useState<any>(null);
  const userNameRef = useRef(null);
  const [tags, setTags] = useState<any>(null);
  const loadingBarRef = useRef(null);
  const [isInitialLoading, setIsInitialLoading] = useState(false);

  useEffect(() => {
    const idx = streamingAssistantIdxRef.current;
    if (idx === null) return;
    const assistantMsg = chatMessages[idx];
    if (!assistantMsg || assistantMsg.role !== "assistant") return;
    setAiPopupMessages((prev) => {
      const copy = [...prev];
      const existingIdx = copy.findIndex((m) => m.id === assistantMsg.id);
      if (existingIdx >= 0) {
        copy[existingIdx] = {
          ...copy[existingIdx],
          content: assistantMsg.content,
        };
      } else {
        copy.push({
          role: "assistant",
          content: assistantMsg.content,
          id: assistantMsg.id,
        });
      }
      return copy;
    });
  }, [chatMessages]);

  useEffect(() => {
    if (aiPopupScrollRef.current) {
      aiPopupScrollRef.current.scrollTop =
        aiPopupScrollRef.current.scrollHeight;
    }
  }, [aiPopupMessages, isChatLoading, streamStatus]);

  const handleAiPopupSubmit = (e?: React.FormEvent | React.KeyboardEvent) => {
    if (e) e.preventDefault();
    if (!aiPopupInput.trim() || isChatLoading) return;
    const userText = aiPopupInput.trim();
    const historyForApi = aiPopupMessages.map((m) => ({
      role: m.role,
      content: m.content,
    }));
    setAiPopupInput("");
    setAiPopupMessages((prev) => [
      ...prev,
      { role: "user", content: userText },
    ]);
    streamingAssistantIdxRef.current = chatMessages.length;
    const ongoingPayload: any = {
      message: userText,
      entityType: "job_create",
      entityId: jobId || "",
      history: historyForApi,
    };
    dispatch(streamBotResponse(ongoingPayload) as any);
  };

  const handleAiPopupKeyDown = (
    e: React.KeyboardEvent<HTMLTextAreaElement>,
  ) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleAiPopupSubmit();
    }
  };

  useEffect(() => {
    if (baseId) {
      const fetchData1 = async () => {
        // Try getting base details from localStorage
        const storedBase = localStorage.getItem("baseDetails");
        if (storedBase) {
          setUpdateBaseLogo(JSON.parse(storedBase));
        } else {
          // If not found in localStorage, fetch from API
          try {
            const baseResponse = await dispatch(baseDetailsData(baseId));
            // local stroage
            localStorage.setItem(
              "baseDetails",
              JSON.stringify(baseResponse.payload),
            );
            setUpdateBaseLogo(baseResponse.payload);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };

      fetchData1();
    }
  }, [baseId, dispatch]);

  // fetch base name
  useEffect(() => {
    const storedData = localStorage.getItem("baseDetails");
    const finalData = storedData;

    if (finalData) {
      try {
        const parsedData =
          typeof finalData === "string" ? JSON.parse(finalData) : finalData;

        if (parsedData?.data?.base?.name) {
          setUpdateChannelName(parsedData?.data?.base?.name);
        } else if (finalData?.name) {
          setUpdateChannelName(parsedData?.name);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, []);

  // fetch base logo
  useEffect(() => {
    const storedData = localStorage.getItem("userDetails");
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (parsedData && parsedData.profile_pic) {
          setUpdateProfileImage(parsedData && parsedData.profile_pic);
        }
      } catch (error) {
        console.error("Error parsing stored channel data:", error);
      }
    }
  }, [updateBaseLogo]);

  const imageUrl =
    updateProfileImage &&
    `${process.env.REACT_APP_API_BASE_URL}/${updateProfileImage}`;

  const handleSignOut = () => {
    const clearAllStorageData = () => {
      // Clear all localStorage
      localStorage.clear();

      // Specifically remove items related to authentication and persistence
      const keysToRemove = [
        "accessToken",
        "authToken",
        "persist:root",
        "_persist",
      ];
      keysToRemove.forEach((key) => localStorage.removeItem(key));
    };

    dispatch(logoutUser())
      .then((resultAction) => {
        if (logoutUser.fulfilled.match(resultAction)) {
          clearAllStorageData();
          toast.success("Successfully logged out!");

          // Use a slight delay to ensure storage clearing is complete
          setTimeout(() => {
            navigate("/login");
          }, 100);
        } else if (logoutUser.rejected.match(resultAction)) {
          const payload = resultAction.payload as {
            status?: number;
            message: string;
          };
          if (payload.status === 401) {
            clearAllStorageData();
            toast.error("Session expired. Please log in again.");

            setTimeout(() => {
              window.location.href = "/login";
            }, 100);
          } else {
            toast.error("Logout failed. Please try again.");
          }
        }
      })
      .catch((error) => {
        console.error("Logout action failed", error);
        toast.error("Logout action failed. Please try again.");
      });
  };

  // user details
  useEffect(() => {
    const userDetailsString = localStorage.getItem("userDetails");

    if (userDetailsString) {
      try {
        const userDetails = JSON.parse(userDetailsString);
        setUserData(userDetails);
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  }, []);

  useEffect(() => {
    const userBaseDetailsString = localStorage.getItem("baseDetails");
    if (userBaseDetailsString) {
      try {
        const userBaseDetails = JSON.parse(userBaseDetailsString); // Declare the variable here
        setUserBaseData(userBaseDetails?.data);
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  }, []);

  useEffect(() => {
    const storedUserDetails = JSON.parse(
      localStorage.getItem("userDetails") || "{}",
    );
    setUserId(storedUserDetails);
  }, []);

  const handleBaseNavigate = () => {
    navigate("/base");
  };

  const handleProfileSetting = () => {
    navigate(`/user/${userId?.id}/profile`);
  };

  const handleBaseSetting = () => {
    navigate(`/${baseId}/settings/base/`);
  };

  // custom dropdown
  const profileMenuSections = [
    {
      options: [
        {
          icon: CustomUserIcon,
          label: userData?.name,
          onClick: () => console.log("Profile clicked"),
        },
        {
          icon: ProfileSettingIcon,
          label: "Profile Setting",
          onClick: handleProfileSetting,
        },
      ],
    },
    {
      options: [
        {
          icon: baseNameIcon,
          label: userBaseData?.base?.name || userDetailsFromRedux?.name,
          onClick: () => console.log("Profile clicked"),
        },
        {
          icon: UserRoleIcon,
          label: userData?.role || userBaseData?.base?.role,
          onClick: () => console.log("Profile clicked"),
        },
        // { icon: CogIcon, label: 'Base Setting', onClick: handleBaseSetting },
        ...(userData?.role === "admin"
          ? [
              {
                icon: BaseSettingIcon,
                label: "Base Setting",
                onClick: handleBaseSetting,
              },
            ]
          : []),
      ],
    },
    {
      options: [
        {
          icon: SwitchBaseIcon,
          label: "Create/Switch Base",
          onClick: handleBaseNavigate,
        },
      ],
    },
    {
      options: [
        { icon: LogoutIcon, label: "Sign out", onClick: handleSignOut },
      ],
    },
  ];

  const loadMoreActivities = async () => {
    if (allActivityItem.hasNextPage && !isLoading && shouldLoadMore) {
      setIsLoading(true);
      try {
        const nextPage = allActivityItem.currentPage + 1;
        const fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/jobPost.myList?page=${nextPage}&limit=${allActivityItem.limit}`;

        // // Add message type to the URL if a specific type is selected
        // if (activeMessageType && activeMessageType !== 'all') {
        //   fullUrl += `&type=${activeMessageType}`;
        // }

        // department
        // if (selectedDepartment && selectedDepartment !== 'all') {
        //   fullUrl += `&job_department_id=${selectedDepartment.id}`;
        // }

        const response = await _baseRequest(fullUrl, "GET");

        if (
          response.status === 200 &&
          response.data.jobPost &&
          response.data.jobPost.length > 0
        ) {
          setAllActivityItem((prevState) => ({
            ...response.data,
            jobPost: [...prevState.jobPost, ...response.data.jobPost],
          }));
        } else {
          setAllActivityItem((prevState) => ({
            ...prevState,
            hasNextPage: false,
          }));
        }
      } catch (error) {
        console.error("Error fetching more activities:", error);
      } finally {
        setIsLoading(false);
        setShouldLoadMore(false);
      }
    }
  };

  const debouncedHandleScroll = debounce(() => {
    if (listRef.current && allActivityItem.hasNextPage && !isLoading) {
      const { scrollTop, scrollHeight, clientHeight } = listRef.current;
      if (scrollHeight - scrollTop <= clientHeight * 1.5) {
        setShouldLoadMore(true);
      }
    }
  }, 200);

  useEffect(() => {
    if (shouldLoadMore) {
      loadMoreActivities();
    }
  }, [shouldLoadMore]);

  useEffect(() => {
    const fetchInitialData = async () => {
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/jobPost.myList?page=1&limit=${allActivityItem.limit}`;

      // Add message type to the URL if a specific type is selected
      //   if (activeMessageType && activeMessageType !== 'all') {
      //     fullUrl += `&type=${activeMessageType}`;
      //   }

      // Only add department filter if it's not "All"
      //   if (selectedDepartment && selectedDepartment.id !== 'all') {
      //     fullUrl += `&job_department_id=${selectedDepartment.id}`;
      //   }

      try {
        setIsLoading(true);
        setIsInitialLoading(true);
        loadingBarRef.current?.continuousStart();
        const response = await _baseRequest(fullUrl, "GET");

        if (response?.data?.jobPost && response?.data?.jobPost?.length > 0) {
          setAllActivityItem(response?.data);
        } else {
          setAllActivityItem({
            jobPost: [],
            totalJobPost: 0,
            currentPage: 1,
            hasNextPage: false,
            limit: 25,
            totalPages: 1,
          });
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setIsLoading(false);
        setIsInitialLoading(false);
        loadingBarRef.current?.complete();
      }
    };

    if (baseId) {
      fetchInitialData();
    }
  }, [baseId]);

  // teams
  // useEffect(() => {
  //   if (baseId) {
  //     const fetchTeams = async () => {

  //       try {
  //         const baseResponse = await dispatch(fetchDepartmentList(baseId));
  //         setTeamsNew(baseResponse.payload);
  //       } catch (error) {
  //         console.error("Error fetching base member details:", error);
  //       }
  //     }

  //     fetchTeams();
  //   }
  // }, [baseId, dispatch]);

  const handleTabClick = async (item: any) => {
    if (!item || !item.id) {
      console.error("Invalid item provided");
      return;
    }
    // Navigate after API call is complete
    navigate(`/${baseId}/job/${item.id}/dashboard`);
    localStorage.removeItem("jobActionData");
    localStorage.removeItem("jobByReviewData");
    localStorage.removeItem("jobPipelineStageData");
    localStorage.removeItem("jobPostDetailsData");
    localStorage.removeItem("jobByHiringTeamMembers");
    localStorage.removeItem("activeFiltersJobApplication");
    localStorage.removeItem("activeFiltersJobApplicationKanban");
    localStorage.removeItem("activeFiltersJobReports");
    localStorage.removeItem("cachedJobsDetailsListData");
    localStorage.removeItem("baseScoreCardDataByJob");
    localStorage.removeItem("baseQuestionnaireDataByJob");

    localStorage.removeItem("baseJobListingData");
    localStorage.removeItem("activeFiltersTopics");
    localStorage.removeItem("cachedJobsListData");
    localStorage.removeItem("baseJobScoreCardData");
    localStorage.removeItem("baseScoreCardDataByJob");
    localStorage.removeItem("baseQuestionnaireDataByJob");
    localStorage.removeItem("jobPipelineStageData");
    localStorage.removeItem("activeFiltersJobApplication");
    localStorage.removeItem("activeFiltersJobsListing");
    localStorage.removeItem("activeFiltersJobsDetailsPage");
    localStorage.removeItem("activeFiltersJobApplicationKanban");
    localStorage.removeItem("jobByHiringTeamMembers");
    localStorage.removeItem("jobActionData");
    localStorage.removeItem("jobByReviewData");
    localStorage.removeItem("jobPostDetailsData");
    localStorage.removeItem("JobPipelineDetailsData");
    localStorage.removeItem("activeFiltersBookmark");
    localStorage.removeItem("cachedBookmarkData");
    localStorage.removeItem("forgot_email");
    try {
      const baseResponse = await dispatch(
        fetchDocument({
          baseId,
          id: item.id, // Use item.id instead of jobId
        }),
      );

      if (baseResponse?.payload?.data) {
        localStorage.setItem(
          "jobPostDetailsData",
          JSON.stringify(baseResponse.payload.data),
        );
      }
    } catch (error) {
      console.error("Error fetching document details:", error);
      // You might want to show an error toast here
    }
  };

  // location
  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("baseLocationData");
        if (storedBase) {
          setLocation(JSON.parse(storedBase));
        } else {
          try {
            const baseResponse = await dispatch(fetchLocationList(baseId));
            setLocation(baseResponse.payload);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  // Process job locations whenever job posts or location data changes
  useEffect(() => {
    if (jobPost && jobPost.length > 0 && location?.data.length > 0) {
      const locationsMap = {};

      jobPost.forEach((job) => {
        if (job.job_location) {
          // Split location IDs if there are multiple
          const locationIds = job.job_location
            .split(",")
            .map((id) => id.trim());

          // Find all matching locations
          const locationMatches = location?.data.filter((loc) =>
            locationIds.includes(loc.id),
          );

          // Set location names (joining if multiple)
          if (locationMatches.length > 0) {
            const locationNames = locationMatches.map(
              (match) => match.location_name,
            );
            locationsMap[job.id] = locationNames.join(" - ");
          }
        }
      });

      setJobLocations(locationsMap);
    }
  }, [jobPost, location]);

  // dashboard api call
  // useEffect(() => {
  //   if (baseId) {
  //     const fetchData = async () => {
  //       const storedBaseMember = localStorage.getItem('jobByHiringTeamMembers');
  //       if (storedBaseMember) {
  //         setBaseMemberDetails(JSON.parse(storedBaseMember));
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(fetchJobPipelineDetailsData(baseId));
  //           localStorage.setItem('jobByHiringTeamMembers', JSON.stringify(baseResponse.payload));
  //           setBaseMemberDetails(baseResponse.payload);
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };
  //     fetchData();
  //   }
  // }, [baseId, dispatch]);

  //

  // useEffect(() => {
  //   if (baseId) {
  //     const fetchData = async () => {
  //       const storedBaseMember = localStorage.getItem('baseMembersDetails');
  //       if (storedBaseMember) {
  //         setBaseMemberDetails(JSON.parse(storedBaseMember));
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(baseMemberDetailsData(baseId));
  //           setBaseMemberDetails(baseResponse.payload);
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };
  //     fetchData();
  //   }
  // }, [baseId, dispatch]);

  // useEffect(() => {
  //   if (baseId) {
  //     const fetchData1 = async () => {

  //       const storedBase = localStorage.getItem('baseDetails');
  //       if (storedBase) {
  //         setBaseDetails(JSON.parse(storedBase));
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(baseDetailsData(baseId));
  //           setBaseDetails(baseResponse.payload);
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };
  //     fetchData1();
  //   }
  // }, [baseId, dispatch]);

  // teams
  // useEffect(() => {
  //   if (baseId) {
  //     const fetchTeams = async () => {
  //       const storedBase = localStorage.getItem('baseTeamsData');
  //       if (storedBase) {
  //         setTeams(JSON.parse(storedBase));
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(fetchBoardsList(baseId));
  //           setTeams(baseResponse.payload);
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };
  //     fetchTeams();
  //   }
  // }, [baseId, dispatch]);

  // switch base
  // useEffect(() => {
  //   if (baseId) {
  //     const fetchData = async () => {
  //       const storedBaseMember = localStorage.getItem('baseSwitchDetails');
  //       if (storedBaseMember) {
  //         setBaseSwitchMemberDetails(JSON.parse(storedBaseMember));
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(baseSwitchMemberDetailsData(baseId));
  //           setBaseSwitchMemberDetails(baseResponse.payload);
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };
  //     fetchData();
  //   }
  // }, [baseId, dispatch]);

  // department
  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("baseDepartmentData");
        if (storedBase) {
          setTeams(JSON.parse(storedBase));
        } else {
          try {
            const baseResponse = await dispatch(fetchDepartmentList(baseId));

            setTeams(baseResponse.payload);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  // location
  // useEffect(() => {
  //   if (baseId) {
  //     const fetchTeams = async () => {
  //       const storedBase = localStorage.getItem('baseLocationData');
  //       if (storedBase) {
  //         setLocationNew(JSON.parse(storedBase));
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(fetchLocationList(userDetails?.id || baseId));
  //           setLocationNew(baseResponse.payload);
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };
  //     fetchTeams();
  //   }
  // }, [baseId, dispatch]);

  // pipeline
  // useEffect(() => {
  //   if (baseId) {
  //     const fetchTeams = async () => {
  //       const storedBase = localStorage.getItem('basePiplineData');
  //       if (storedBase) {
  //         setPipeline(JSON.parse(storedBase));
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(fetchPipelineList(baseId));
  //           setPipeline(baseResponse.payload);
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };
  //     fetchTeams();
  //   }
  // }, [baseId, dispatch]);

  // switch base
  // useEffect(() => {
  //   if (baseId) {
  //     const fetchData = async () => {
  //       const storedBaseMember = localStorage.getItem('baseSwitchDetails');
  //       if (storedBaseMember) {
  //         setBaseSwitchMemberDetails(JSON.parse(storedBaseMember));
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(baseSwitchMemberDetailsData(baseId));
  //           localStorage.setItem('baseSwitchDetails', JSON.stringify(baseResponse.payload))
  //           setBaseSwitchMemberDetails(baseResponse.payload);
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };
  //     fetchData();
  //   }
  // }, [baseId, dispatch]);

  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("baseTagsData");
        if (storedBase) {
          setTags(JSON.parse(storedBase));
        } else {
          try {
            const baseResponse = await dispatch(
              fetchPipelineStagesList({ baseId: baseId }),
            );

            if (baseResponse?.payload) {
              setTags(baseResponse.payload);
            }
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  useEffect(() => {
    // if (baseMemberDetails) {
    //   localStorage.setItem('baseMembersDetails', JSON.stringify(baseMemberDetails));
    // }
    // if (baseDetails) {
    //   localStorage.setItem('baseDetails', JSON.stringify(baseDetails));
    // }
    // if (baseSwitchMemberDetails) {
    //   localStorage.setItem('baseSwitchDetails', JSON.stringify(baseSwitchMemberDetails));
    // }
    if (teams) {
      localStorage.setItem("baseDepartmentData", JSON.stringify(teams));
    }
    // if (location) {
    //   localStorage.setItem('baseLocationData', JSON.stringify(location));
    // }
    if (tags) {
      localStorage.setItem("baseTagsData", JSON.stringify(tags));
    }
  }, [teams, tags]);

  const handleFeedbacksModal = () => {
    // setFeedbackOpen(true);
    navigate(`/${baseId}/newjob`);
  };

  if (!teams || !tags) {
    return <div></div>;
  }

  return (
    <div className="mt-[0px] h-[calc(100vh_-_62px)]  overflow-y-auto py-[32px] ring-1 lg:ring-zinc-950/5 shadow-xs rounded-tl-none rounded-tr-lg rounded-bl-none rounded-br-lg">
      <LoadingBar color="#ff591e" ref={loadingBarRef} />
      <div className="w-full max-w-[710px] mx-auto">
        {/* <header className="flex items-center px-4 h-[56px]">
          <div className="min-w-0 flex-1 h-full">
            <nav className="flex flex-1 items-center gap-4 py-2.5">
              <div className="flex shrink-0 items-center px-[0rem] justify-between w-full">
                <div className='flex gap-[0.5rem] items-center cursor-pointer h-[32px] px-[0rem] w-full'>
                  {
                    updateBaseLogo?.data?.base?.logo &&
                    <img
                      className="h-6 w-6 rounded-[5px]"
                      src={`${process.env.REACT_APP_API_BASE_URL}/${updateBaseLogo?.data?.base?.logo}`}
                      alt="base logo"
                    />
                  }
                  {
                    updateBaseLogo?.data?.base?.name &&
                    <span className='leading-[1.2] font-semibold whitespace-nowrap text-[0.8125rem] cursor-pointer truncate w-full max-w-[160px] min-w-[140px] overflow-hidden text-ellipsis
                    text-start capitalize '>{updateBaseLogo?.data?.base.name}</span>
                  }
                </div>




                <div className="flex items-center gap-x-4 lg:gap-x-6 w-[450px] relative z-50 [&>button]:hover:bg-transparent justify-end">
                  <CreateJob />

                  <div className='flex items-center gap-x-2'>
                    <CustomMenuDropdownVertical
                      imageUrl={imageUrl}
                      altText="User profile"
                      sections={profileMenuSections}
                      menuItemsClassName="left-auto origin-top-right bottom-[auto] right-[-34px]"
                      triggerRef={userNameRef} 
                    />
                    <span className='text-[13px] font-medium text-wedges-gray-900 capitalize cursor-pointer hover:bg-gray-200  px-2 py-[2px] rounded-md'
                      onClick={() => userNameRef.current?.click()}
                    >{userData?.name}</span>
                  </div>

                </div>

              </div>

            </nav>
          </div>
        </header> */}

        <main className="flex flex-1 flex-col pb-2 lg:px-2">
          <div className="mx-auto w-full max-w-[710px]">
            <div className="flex justify-between w-full">
              <h1 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize">
                Job list
              </h1>
              <div className="flex justify-center gap-2">
                <button
                  type="button"
                  onClick={() => {
                    dispatch(setStreamDoneResponse(null));
                    setIsAiPopupOpen(true);
                  }}
                  className="rounded-md duration-200 font-[600] text-[0.8125rem] h-[28px] w-[28px] flex items-center justify-center border border-solid border-[#e7e7e8] hover:bg-gray-50"
                  aria-label="AI Assistant"
                >
                  <span
                    data-title={"AI Assistant"}
                    className="table-tooltip-list before:!bottom-[-35px] before:!left-[3px] before:!text-[12px]"
                  >
                    <SparkleIconComponent
                      className="w-[1rem] h-[1rem] text-[#808080]"
                      aria-hidden="true"
                    />
                  </span>
                </button>
                <button
                  className="group inline-flex shrink-0 select-none items-center transition-colors duration-100 wg-antialiased focus:outline-0
                     focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 px-8px py-1 
                     rounded-md text-white outline-primary disabled:opacity-50  hover:bg-indigo-500 bg-indigo-600 h-[28px]
                     justify-start [&>span]:flex [&>span]:items-center [&>span]:gap-[6px] font-medium text-[.8125rem] leading-6 px-[14px]"
                  onClick={handleFeedbacksModal}
                >
                  <span className="px-0 capitalize">
                    {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="#232529"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-circle-plus w-[1rem] h-[1rem] text-black-100"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
              <path d="M9 12h6" />
              <path d="M12 9v6" />
            </svg> */}
                    Create job posting
                  </span>
                </button>
              </div>
            </div>
            <div className="bg-[#e0e0e0] w-full h-[1px] mt-7 mb-8"></div>

            <ul
              className=" relative w-full h-full p-[0px]"
              ref={listRef}
              onScroll={debouncedHandleScroll}
            >
              {isLoading && jobPost.length === 0 ? (
                <div className="flex items-center justify-center w-full h-[calc(100vh_-_300px)]">
                  <div className="simple-spinner-loader">
                    <span></span>
                  </div>
                </div>
              ) : (
                // Your existing list rendering code
                jobPost.map((item, index) => {
                  const channelId = item.job_department_id;
                  const currentChannel = teams?.data?.find(
                    (team) => team.id.toString() === channelId,
                  );
                  const channelName = currentChannel
                    ? currentChannel.department_name
                    : "";
                  const channelColor = currentChannel
                    ? currentChannel.department_color
                    : "gray";

                  const locationName = jobLocations[item.id];
                  const { inbox, screening, hired, reject } = item;

                  return (
                    <div className="w-full" key={index}>
                      <div className="w-full">
                        <li
                          key={item.id}
                          className="mb-5 text-sm p-0 w-full"
                          onClick={() => handleTabClick(item)}
                        >
                          <div
                            className={`rounded-md p-0 flex items-center cursor-pointer ring-1 ring-gray-200 feedback-delete-hover`}
                          >
                            <div className="p-3 w-[75%] h-full gap-2 flex flex-col gap-y-2">
                              <div className="flex items-center flex-row gap-2 justify-between">
                                <div className="line-clamp-1 text-[14px] text-[#000000EB] capitalize font-medium">
                                  {item.job_title}
                                </div>
                                {/* {
                                  item.bookmark_id &&
                                  <span data-title={'Bookmarked'} className=' table-tooltip-list before:!bottom-[18px] before:!left-[11px] before:!text-[12px]' >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="currentColor"
                                      className="icon icon-tabler icons-tabler-filled icon-tabler-bookmark w-[1rem] h-[1rem] text-[#808080] mr-[-4px]"
                                    >
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                      <path d="M14 2a5 5 0 0 1 5 5v14a1 1 0 0 1 -1.555 .832l-5.445 -3.63l-5.444 3.63a1 1 0 0 1 -1.55 -.72l-.006 -.112v-14a5 5 0 0 1 5 -5h4z" />
                                    </svg>
                                  </span>
                                } */}
                              </div>
                              <div className="flex items-center flex-row gap-2">
                                <div className="flex-1 ">
                                  <div className="flex items-center flex-wrap gap-[6px] ">
                                    {item.job_ref_id && (
                                      <span
                                        data-title={"job reference Id"}
                                        className=" table-tooltip-list before:!bottom-[28px] before:!left-[24px] before:!text-[12px]"
                                      >
                                        <span
                                          className="flex items-center gap-[6px]  text-[13px] capitalize  rounded-md bg-gray-50 px-2 py-1 
   text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
                                        >
                                          #{item.job_ref_id}
                                        </span>
                                      </span>
                                    )}
                                    {item.role && (
                                      <span
                                        data-title={"job role"}
                                        className=" table-tooltip-list before:!bottom-[28px] before:!left-[24px] before:!text-[12px]"
                                      >
                                        <span
                                          className="flex items-center gap-[6px]  text-[13px] capitalize  rounded-md bg-gray-50 px-2 py-1 
   text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
                                        >
                                          {item.role}
                                        </span>
                                      </span>
                                    )}
                                    {channelName && (
                                      <span
                                        data-title={"department"}
                                        className=" table-tooltip-list before:!bottom-[28px] before:!left-[50px] before:!text-[12px]"
                                      >
                                        <p
                                          className="flex items-center gap-[6px]  text-[13px] capitalize 
                                       rounded-md bg-gray-50 px-2 py-1  text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
                                        >
                                          {channelColor && (
                                            <span
                                              className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px]
                                                border-none text-[0.625rem] font-medium text-white capitalize bg-[${channelColor}]`}
                                            ></span>
                                          )}
                                          {channelName}
                                        </p>
                                      </span>
                                    )}

                                    {locationName && (
                                      <span
                                        data-title={"location"}
                                        className=" table-tooltip-list before:!bottom-[28px] before:!left-[64px] before:!text-[12px]"
                                      >
                                        <span
                                          className="flex items-center gap-[6px]  text-[13px] capitalize  rounded-md bg-gray-50 px-2 py-1 
                                        text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
                                        >
                                          {locationName}
                                        </span>
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* border-l border-solid border-[#e0e0e0] */}
                            <div className="w-[25%] ">
                              <div className="flex flex-col gap-y-1 p-3">
                                <div className="flex flex-row justify-end items-center gap-x-[6px]">
                                  <span className="line-clamp-1 text-[13px] text-[#000000EB] capitalize">
                                    Total
                                  </span>

                                  <div
                                    className="flex items-center gap-[6px]  text-[13px] capitalize 
                      rounded-md bg-gray-50 px-2 py-1  w-fit text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
                                  >
                                    {item.app_count}
                                  </div>
                                </div>

                                <div className="flex flex-row justify-end items-center gap-x-[6px]">
                                  <div className="flex items-center ml-[0px]">
                                    <button
                                      data-title={"Inbox"}
                                      className=" table-tooltip-list before:!bottom-[28px] before:!left-[11px] before:!text-[12px] px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-medium py-[5px]
         border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tl-md rounded-bl-md bg-gray-50 font-mediumium text-[#0000007a] "
                                    >
                                      {inbox}
                                    </button>
                                    <button
                                      data-title={"Screening"}
                                      className="table-tooltip-list before:!bottom-[28px] before:!left-[11px] before:!text-[12px] px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-medium py-[5px] 
              border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  bg-blue-50 text-[#0000007a]"
                                    >
                                      {screening}
                                    </button>
                                    <button
                                      data-title={"Hired"}
                                      className="table-tooltip-list before:!bottom-[28px] before:!left-[11px] before:!text-[12px] px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-medium py-[5px] 
              border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  bg-green-50 text-[#0000007a]"
                                    >
                                      {hired}
                                    </button>
                                    <button
                                      data-title={"Reject"}
                                      className="table-tooltip-list before:!bottom-[28px] before:!left-[11px] before:!text-[12px] px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-medium py-[5px] border
         border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tr-md rounded-br-md bg-red-50 text-[#0000007a] "
                                    >
                                      {reject}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>
                  );
                })
              )}

              {isLoading && jobPost.hasNextPage && (
                <div className=" flex items-center justify-center relative z-50 h-[25px]">
                  <div className="simple-spinner-loader">
                    <span></span>
                  </div>
                </div>
              )}
              {!isLoading && jobPost.hasNextPage && (
                <p className="text-center my-4 text-[12px] text-gray-500">
                  No more results.
                </p>
              )}
              {!isLoading && !jobPost.hasNextPage && jobPost.length === 0 && (
                <div
                  className="w-full mt-0 flex justify-center items-center flex-col gap-y-3"
                  style={{ height: "calc(100vh - 420px)" }}
                >
                  <ExclamationIcon />
                  <p className="text-[#0000007a] text-[13px]">
                    No results found
                  </p>
                </div>
              )}
            </ul>
          </div>
        </main>
      </div>

      {isAiPopupOpen && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40">
          <div className="w-full max-w-[560px] mx-4 bg-white rounded-xl shadow-xl flex flex-col max-h-[80vh] overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
              <h3 className="font-semibold text-[15px] text-[#09090b] flex items-center gap-2">
                <SparkleIconComponent className="w-4 h-4 text-[#808080]" />
                AI Assistant
              </h3>
              <button
                type="button"
                onClick={() => setIsAiPopupOpen(false)}
                className="h-7 w-7 rounded-full text-gray-400 hover:text-gray-700 hover:bg-gray-100 flex items-center justify-center"
                aria-label="Close"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          {/* bg-[#fafafa] */}
            <div
              ref={aiPopupScrollRef}
              className="flex-1 overflow-y-auto p-4 space-y-3 "
            >
              {aiPopupMessages.length === 0 && !isChatLoading && (
                <div className="flex flex-col items-center justify-center h-full text-center py-10">
                  <SparkleIconComponent className="w-10 h-10 text-[#c0c0c0]" />
                  <p className="text-sm text-gray-500 mt-3">
                   Create a new job by describing the position, responsibilities, qualifications, and other requirements...
                  </p>
                </div>
              )}
              {aiPopupMessages.map((msg, i) => (
                <div
                  key={msg.id || i}
                  className={`flex ${msg.role === "user" ? "justify-end" : "justify-start"}`}
                >
                  <div
                    className={`rounded-[20px] ${
                      msg.role === "user"
                        ? "bg-indigo-600 text-white border-transparent ml-4 py-2 px-3"
                        : "text-gray-800  bg-[#f5f5f5] mr-4 [&_p]:my-1 [&_strong]:font-semibold [&_a]:text-blue-600 [&_a]:underline py-3 px-4"
                    }`}
                  >
                    {msg.role === "assistant" &&
                    /<[a-z][\s\S]*>/i.test(msg.content) ? (
                      <span dangerouslySetInnerHTML={{ __html: msg.content }} />
                    ) : (
                      msg.content
                    )}
                  </div>
                </div>
              ))}
              {isChatLoading && (
                <div className="mr-auto max-w-[85%] flex items-center gap-2 px-3 py-2 text-[13px] text-gray-500 bg-white border border-gray-200/60 rounded-xl ">
                  <span className="inline-flex gap-1">
                    <span className="h-1.5 w-1.5 rounded-full bg-gray-400 animate-bounce [animation-delay:-0.3s]" />
                    <span className="h-1.5 w-1.5 rounded-full bg-gray-400 animate-bounce [animation-delay:-0.15s]" />
                    <span className="h-1.5 w-1.5 rounded-full bg-gray-400 animate-bounce" />
                  </span>
                  <span className="font-medium">
                    {streamStatus || "Thinking..."}
                  </span>
                </div>
              )}
            </div>
          {/* bg-[#f0f4f9] border-t */}
            <form
              onSubmit={handleAiPopupSubmit}
              onClick={() => textareaRef.current?.focus()}
              className="py-3 px-4 border-gray-200/60 shrink-0 "
            >
              <div className="relative border border-gray-200 rounded-[16px] p-2 flex flex-col bg-white gap-1 focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600">
                <textarea
                  ref={textareaRef}
                  value={aiPopupInput}
                  onChange={(e) => setAiPopupInput(e.target.value)}
                  onKeyDown={handleAiPopupKeyDown}
                  placeholder="Message..."
                  rows={1}
                  className="w-full resize-none outline-none text-[14px] focus:border-0 focus:ring-0 placeholder:text-gray-400 bg-transparent min-h-[28px] border-0 px-1 py-1.5 leading-relaxed"
                  disabled={isChatLoading}
                />
                <div className="flex items-center justify-end w-full">
                  <button
                    type="submit"
                    disabled={isChatLoading || !aiPopupInput.trim()}
                    className={`h-7 w-7 rounded-full flex items-center justify-center transition-all ${
                      aiPopupInput.trim() && !isChatLoading
                        ? "bg-indigo-600 text-white hover:opacity-90 cursor-pointer"
                        : "bg-gray-100 text-gray-400 cursor-not-allowed"
                    }`}
                    aria-label="Send message"
                  >
                    <ArrowUp className="h-3.5 w-3.5 stroke-[3]" />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
